import React from "react";
import DOMPurify from "dompurify";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";

const CardCommon = ({ title, subtitle, body, onClick, }) => {


  return (
    <>
      <div style={{ textAlign: "left" }}>
        <Card sx={{ alignContent: "begin", minWidth: 300, minHeight: 350 }}>
          <CardContent sx={{ alignContent: "begin" }}>
            <Typography
              sx={{ alignContent: "begin" }}
              variant="h5"
              component="div"
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {subtitle}
              </Typography>
            )}
            <Typography sx={{ mt: 2 }} variant="body2">
              <span
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }}
              />
            </Typography>
          </CardContent>
          {onClick && (
            <CardActions>
              <Button variant="contained" size="small" onClick={onClick}>
                Edit
              </Button>
            </CardActions>
          )}
        </Card>
      </div>
    </>
  );
};

export default CardCommon;
